import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { ClassesComponent } from './classes.component';
import { ClassesHomeComponent } from './components/home/classes-home.component';
import { ClassesAttachedComponent } from './components/attached/classes-attached.component';
import { ClassesRankingComponent } from './components/ranking/list/classes-ranking.component';
import { ClassesRankingClassifComponent } from './components/ranking/classification/classes-ranking-classif.component';

/* Routes */
import { ClassesRoutingModule } from './classes-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        ClassesComponent,
        ClassesHomeComponent,
        ClassesAttachedComponent,
        ClassesRankingComponent,
        ClassesRankingClassifComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        ClassesRoutingModule,
        // NgbModule,

        ThemeModule,
        Interceptor,
    ],
})
export class ClassesModule {}
